import * as Routes from "../../routes";
interface item {
  name: string;
  link?: string;
  notImplemented?: boolean;
  target?: string;
  disabled?: boolean;
}
export interface SideBarSubMenuItemProps {
  name: string;
  link?: string;
  notImplemented?: boolean;
  target?: string;
  Icon?: React.ComponentType<any>;
  items?: item[];
  disabled?: boolean;
}

export interface SideBarSubMenuProps {
  menuItems?: SideBarSubMenuItemProps[];
}

import { useTheme } from "@mui/material";
import {
  BookOpenText,
  Bot,
  ChartColumnIncreasing,
  CircleDollarSign,
  CodeXml,
  Database,
  House,
  Map,
  NotebookText,
  Settings,
  Shield,
  SquareScissors,
  WandSparkles,
} from "lucide-react";

export const getMenuItems = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  var menuItems = [
    {
      name: "Home",
      link: Routes.hub,
      IconLeft: House,
    },
    {
      name: "Explorer",
      link: Routes.dataExplorer,
      IconLeft: Map,
    },
    {
      name: "Clip",
      link: "",
      IconLeft: SquareScissors,
      subMenus: [
        { name: "Clip UI", link: Routes.clipUi },
        { name: "Clip Management", link: Routes.clipManagement },
      ],
    },
    {
      name: "Catalogue",
      link: Routes.dataCatalogue,
      IconLeft: BookOpenText,
    },
    {
      name: "Datasets",
      link: "",
      IconLeft: Database,
      subMenus: [
        { name: "Standard", link: Routes.dataDownload },
        { name: "My Custom", link: Routes.dataCustomDownload },
      ],
    },
    {
      name: "Batch",
      link: Routes.batchBatches,
      IconLeft: Bot,
    },
    {
      name: "Apps",
      link: Routes.developerApiKeys,
      IconLeft: CodeXml,
    },
    {
      name: "Demos",
      link: Routes.demosPage,
      IconLeft: WandSparkles,
    },
    {
      name: "Documentation",
      link: Routes.docsPage,
      IconLeft: NotebookText,
    },
    {
      name: "Usage",
      link: Routes.developerUsage,
      IconLeft: ChartColumnIncreasing,
    },

    {
      name: "Settings",
      link: "",
      IconLeft: Settings,
      subMenus: [
        {
          name: "General",
          link: Routes.orgGeneralSettings,
        },
        {
          name: "Pending Invitations",
          link: Routes.userPendingInvitations,
        },
        {
          name: "Members",
          link: Routes.orgMembers,
        },
        {
          name: "Subscription",
          link: Routes.orgSubscription,
        },
        {
          name: "Billing",
          link: Routes.orgBillingDetails,
        },
      ],
    },

    {
      name: "Admin",
      link: "",
      IconLeft: Shield,
      adminOnly: true,
      subMenus: [
        { name: "Organisations", link: Routes.adminOrganisations },
        { name: "Demos", link: Routes.adminDemoManagement },
        { name: "Users", link: Routes.adminUsers },
        { name: "Datasets", link: Routes.adminDatasets },
        { name: "Custom Datasets", link: Routes.adminViewCustomDatasets },
        { name: "Releases", link: Routes.adminReleases },
        { name: "Clip Reporting", link: Routes.adminClipReporting },
      ],
    },

    {
      name: "Sales Tools",
      link: "",
      IconLeft: CircleDollarSign,
      salesOnly: true,
      subMenus: [
        { name: "Building Updates", link: Routes.salesToolsRuralSchedule },
        { name: "Opportunities", link: Routes.salesToolsOpportunities },
      ],
    },
  ];

  return menuItems;
};
